import { PawPrint } from "lucide-react";

export const PawTrail = ({ count = 6, className = "", color = "text-marmalade", opacityClass = "opacity-10" }) => (
  <div aria-hidden="true" className={`pointer-events-none flex items-center justify-between ${opacityClass} ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <PawPrint
        key={i}
        className={color}
        strokeWidth={1.5}
        style={{
          width: i % 3 === 0 ? 30 : 22,
          height: i % 3 === 0 ? 30 : 22,
          transform: `rotate(${i % 2 === 0 ? -16 : 14}deg) translateY(${i % 2 === 0 ? -8 : 10}px)`,
        }}
      />
    ))}
  </div>
);

export default PawTrail;
